import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export function createRouter () {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'home',
        component: function () {
          return import('./views/Home.vue')
        }
      },
      {
        path: '/our-shares',
        name: 'our-shares',
        component: function () {
          return import('./views/Our-shares.vue')
        }
      },
      {
        path: '*',
        redirect: '/'
      }
    ],
    scrollBehavior: function (to, from, savedPosition) {
      return savedPosition || { x: 0, y: 0 }
    }
  })
}
